<template>
  <el-dialog
    :title="fuel.name"
    top="5vh"
    visible
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('update:isShow', false)"
  >
    <section v-loading="isLoading">
      <h1>
        Linked Services<br>
        <small>
          Services associated with this Fuel Levy
        </small>
      </h1>
      <el-table
        :data="linkedServices"
        stripe
        size="mini"
      >
        <el-table-column
          label="Service Name"
          prop="carrier_service"
          show-overflow-tooltip
          :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-' "
        />
        <el-table-column
          label="Actions"
          align="right"
          width="80px"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click.native="deleteLinkedService(scope.$index, scope.row)"
            >
              Delete
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="text-center pt-3"
        :current-page.sync="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="perPage"
        layout="total, sizes, prev, pager, next"
        :total="total"
        @size-change="loadTable()"
        @current-change="loadTable()"
      />
    </section>

    <el-divider />

    <section v-loading="isSaving">
      <h1>
        New Service<br>
        <small>
          Link a new Service to this Fuel Levy
        </small>
      </h1>
      <el-form
        ref="serviceForm"
        :rules="rules"
        :model="service"
      >
        <el-row>
          <el-col>
            <el-form-item
              label="Services"
              prop="carrier_service"
            >
              <el-select
                v-model="service.carrier_service"
                filterable
                placeholder="Search Service"
                :loading="isLoadingServices"
                value-key="id"
                class="w-100"
              >
                <el-option
                  v-for="s in services"
                  :key="s.id"
                  :label="s.name"
                  :value="s"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="attachService"
      >
        Link
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    fuel: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      linkedServices: [],
      service: {},
      services: [],
      isLoadingServices: false,
      isFullscreen: false,
      page: 1,
      perPage: 5,
      total: 0,
      isLoading: false,
      isSaving: false,
      datePickerOption: {
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      rules: {
        carrier_service: [
          { required: true, message: 'Service is required', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created () {
    this.loadTable()
    this.loadLists()
    this.service = new this.$sdk.fuel_service()
  },
  methods: {
    loadTable () {
      this.isLoading = true
      this.$sdk.fuel_service.list(builder => {
        builder.filters = { fuel_service_fuel: this.fuel.id }
        builder.include = ['carrier_service']
        builder.page = this.page
        builder.limit = this.perPage
        builder.order = 'name:asc'
      })
        .then(res => {
          this.linkedServices = res
          this.total = res.total
        })
        .finally(() => { this.isLoading = false })
    },
    loadLists () {
      // Services
      this.isLoadingServices = true
      this.$sdk.carrier_service.list(builder => {
        builder.context = {
          resource: 'carrier',
          id: this.fuel.carrier.id
        }
        builder.order = 'name:asc'
        builder.limit = 1000
      }).then(res => { this.services = res })
        .finally(() => { this.isLoadingServices = false })
    },
    attachService () {
      this.$refs.serviceForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.service.fuel = this.fuel
          this.service.create(builder => {
            builder.include = ['carrier_service']
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.service = new this.$sdk.fuel_service()
              this.$refs.serviceForm.resetFields()
              this.loadTable()
            })
        }
      })
    },
    deleteLinkedService (index, row) {
      this.$confirm('Are you sure to delete this?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.isLoading = true
        row.delete()
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => this.loadTable())
      }).catch(() => {})
    }
  }
}
</script>

<style>

</style>
